<template>
  <section>
    <div class="distribuidores__header">
      <b-row class="align-items-center">
        <b-col cols="8">
          <h3 @click="pageNum++">Distribuidores</h3>
        </b-col>
        <b-col cols="4">
          <button
            variant="outline-success"
            class="float-right text-uppercase main-btn"
            @click="nuevoDistribuidor"
          >nuevo</button>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col cols="12" class="my-5">
        <div class="card table-list__container">
          <Table
            v-cloak
            :fields="fields"
            :items="distribuidores"
            :actions="actions"
            :loading="loading"
            :page-num="pageNum"
            :page-size="pageSize"
            :rows="parseTotal"
            @changePage="changePage"
            @delete="deleteDist"
            :search="search"
            @edit="editarDistribuidor"
            class-table="ecommerce-table"
          >
            <template slot="header-content">
              <div class="m-1">
                <b-row>
                  <b-col cols="6">
                    <h3 class="subtitle ml-3 mr-2 total_results">Total de resultados: {{parseTotal}}</h3>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group id="fieldset-1" label-for="searcher">
                      <b-form-input placeholder="buscar" id="searcher" v-model="search" trim></b-form-input>
                      <label for="searcher" class="form__label">Buscar</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template v-slot:rowCell="{ value, labelKey }">
              <b-badge
                v-if="labelKey === 'activo'"
                pill
                :variant="statusColors[value]"
              >{{ itemStatus(value) }}</b-badge>
            </template>
          </Table>
        </div>
      </b-col>
    </b-row>
    <ModalCreateEdit :type="modalType" :distribuidor="distToEdit" />
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Table from "@/components/general/Table";
import ModalCreateEdit from "@/components/distribuidores/ModalCreateEdit";

export default {
  components: {
    Table,
    ModalCreateEdit
  },
  data() {
    return {
      timer: null,
      modalType: "",
      distToEdit: {},
      statusColors: {
        0: "danger",
        1: "success"
      },
      optionsPerPage: [
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" }
      ],
      fields: [
        {
          key: "nombreDistribuidor",
          label: "Nombre del distribuidor",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "email",
          label: "Correo",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "activo",
          label: "Estatus",
          sortDirection: "desc",
          class: "text-center"
        },
        { key: "actions", label: "Acciones", class: "text-center" }
      ],
      actions: [
        {
          name: "edit",
          icon: "fa fa-pen",
          modal: "modal-edit"
        },
        {
          name: "delete",
          icon: "fa fa-trash"
        }
      ]
    };
  },
  async mounted() {
    await this.getEstados();
    await this.getDistribuidores();
  },
  computed: {
    ...mapState("distribuidores", [
      "distribuidores",
      "totalDistribuidores",
      "loading"
    ]),
    parseTotal() {
      return Number(this.totalDistribuidores) || 0;
    },
    pageNum: {
      get() {
        return this.$store.state.distribuidores.pageNum;
      },
      set(value) {
        this.$store.commit("distribuidores/setPageNum", value);
      }
    },
    pageSize: {
      get() {
        return this.$store.state.distribuidores.pageSize;
      },
      set(value) {
        this.$store.commit("distribuidores/setPageSize", value);
      }
    },
    search: {
      get() {
        return this.$store.state.distribuidores.search;
      },
      set(value) {
        this.$store.commit("distribuidores/setSearch", value);
      }
    }
  },
  watch: {
    pageNum() {
      this.getDistribuidores();
    },
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        console.log(this.search);

        this.getDistribuidores();
      }, 500);
    }
  },
  methods: {
    ...mapActions("distribuidores", [
      "getDistribuidores",
      "deleteDistribuidor",
      "getEstados"
    ]),
    ...mapActions("ui", ["makeAlert"]),
    itemStatus(value) {
      if (value === "1") {
        return "Activo";
      }
      return "Inactivo";
    },
    nuevoDistribuidor() {
      this.modalType = "create";
      this.$root.$emit("bv::show::modal", "distribuidor-modal-create");
    },
    editarDistribuidor(data) {
      this.distToEdit = data.item;
      this.modalType = "edit";
      this.$root.$emit("bv::show::modal", "distribuidor-modal-create");
    },
    async deleteDist(data) {
      this.makeAlert({
        icon: "question",
        title: "¿Quieres eliminar a este distribuidor?",
        text: "Esta acción no podra ser modificada",
        showCancelBtn: true
      }).then(async res => {
        if (res.value) {
          await this.deleteDistribuidor(data.item.idDistribuidor);
        }
      });
    },
    changePage(page) {
      this.pageNum = page;
    }
  }
};
</script>

<style>
.distribuidores__header {
  border-bottom: 1px solid;
}

.modal-close-icon {
  color: #7f7f7f;
  cursor: pointer;
  font-size: 1.8rem;
}

.Page.navigation {
  width: max-content;
  margin: auto;
}

.page-item {
  cursor: pointer;
}

.page-link {
  font-size: 1.2rem;
  color: #656565;
  font-weight: 400;
}

.page-item.active .page-link {
  color: white;
  background-color: #656565;
  border: inherit;
}

.subtitle {
  font-size: 1.2rem;
  margin: 0;
}

.total_results {
  vertical-align: middle;
  align-items: center;
  display: flex;
  /* justify-content: center; */
  height: 100%;
}
</style>
